"use client";

import { ArrowRight } from "lucide-react";
import Link from "next/link";

import { CodeCTATracker } from "@/components/LandingTracker";
import { Button } from "@/components/ui/button";
import { useUser } from "@/hooks/useUser";

import { useI18n } from "@llmgateway/i18n/react";

export function GetDevPassButton({
	signupHref = "/signup",
	cta,
	location,
	showArrow = false,
	className,
}: {
	signupHref?: string;
	cta: string;
	location: string;
	showArrow?: boolean;
	className?: string;
}) {
	const { t } = useI18n();
	const { user, isLoading } = useUser();
	const isAuthenticated = !!user && !isLoading;

	return (
		<CodeCTATracker cta={cta} location={location}>
			<Button size="lg" className={className} asChild>
				<Link href={isAuthenticated ? "/dashboard" : signupHref}>
					{isAuthenticated
						? t("pricing.goToDashboard")
						: t("pricing.getYourDevPass")}
					{showArrow && <ArrowRight className="h-4 w-4" />}
				</Link>
			</Button>
		</CodeCTATracker>
	);
}
